import { useEffect, useState } from "react";
import PaginazioneTitoloPulsanteCrea from "../riutilizabili/PaginazioneTitoloPulsanteCrea";
import FiltriGiacenze from "./FiltriGiacenze";
import { format } from "date-fns";
import giacenze_fetch from "../fetch/giacenze_fetch";
import Tabella from "../riutilizabili/Tabella";
import PulsantiFiltra from "../riutilizabili/PulsantiFiltra";


export default function ViewGiacenze() {
    const [inputs , setInputs] = useState({
        dataFine: format(new Date(), 'yyyy-MM-dd'),
        magazzinoNome:'Magazzino Centrale Ancona',
        magazzinoId:1
    });

    const [dati , setDati]= useState([])
    const [aggiorna , setAggiorna] = useState(true)

    useEffect(()=>{
        readGiacenza(inputs)
    },[])

    const readGiacenza = async (params) => {
        const res = await giacenze_fetch.get(params);
        console.log(res.data , ' res');
        setDati(Object.values(res.data))
    }
    const esportaDatiExcell = async () => {
        await giacenze_fetch.inventarioGiacenzaMgExcel(inputs , inputs?.magazzinoNome)
    }

    const hundleChange = (nome , valore) => {
        let tmp = {...inputs};
        if ((''+valore).trim() === '') {
            delete tmp[nome]
        }else{
            tmp[nome] = valore;
        }
        setInputs(tmp)
    }

    const azzera = async ()=> {
        setAggiorna(false)
        setInputs({
            magazzinoNome:'Magazzino Centrale Ancona',
            dataFine: format(new Date(), 'yyyy-MM-dd'),
            magazzinoId:1
        })
        await readGiacenza({
            dataFine: format(new Date(), 'yyyy-MM-dd'),
            magazzinoNome:'Magazzino Centrale Ancona',
            magazzinoId:1
        })
        setAggiorna(true)
    }

    const colonne = [
        {
            id : 1 ,
            Header : 'Rif. interno' ,
            accessor : 'prodotto.rifInterno',
            //Cell : (item)=><div >{item.prodotto.rifInterno}</div>
        },
        {
            id : 2 ,
            Header : 'Descrizione breve' ,
            accessor : 'prodotto.descrizioneBreve',
            //Cell : (item)=><div >{item.prodotto.descrizioneBreve}</div>
        },
        {
            id : 3 ,
            Header : 'Fornitore' ,
            accessor : 'prodotto.infoFornitore',
            Cell : (item)=><div >{item.prodotto?.infoFornitore ? (item.prodotto?.infoFornitore?.ragioneSociale ? item.prodotto?.infoFornitore?.ragioneSociale : item.prodotto?.infoFornitore?.nome+' '+item.prodotto?.infoFornitore?.cognome) : '' }</div>
        },
        {
            id : 4 ,
            Header : 'Quantità' ,
            accessor : 'qta'
        },
        {
            id : 5 ,
            Header : 'U.M.' ,
            accessor : 'prodotto.infoUnitaMisura.nome'
        },
    ]
    
    return(
        <div className="pt-2">
            <PaginazioneTitoloPulsanteCrea titolo={'Giacenze'} funCrea={null} />
            {aggiorna&&<div className="border_filtra p-3 mx-4 px-4" >
                <FiltriGiacenze values={inputs} onChange={hundleChange} />
                <div className="ps-2">
                    <PulsantiFiltra azzera={azzera} filtra={()=>readGiacenza(inputs)} />
                </div>
            </div>}
            <div>
            <div className="d-flex justify-content-end p-4" >
                <button className="btn btn-primary" onClick={esportaDatiExcell} >
                    ESPORTA EXCELL
                </button>
            </div>
            </div>
            <div className=" pt-3" >
                <Tabella
                    columns={colonne}
                    data={dati}
                />
            </div>
        </div>
    )
}